import type { JSX, ReactNode } from 'react';
import type { ParishSummary } from '../api-client';
import { PortalHeader, SignOutMenu, GearIcon } from '@cca/ui';
import { ParishPicker } from './ParishPicker';
import { signOutAllDevices, signOutThisDevice } from './signout';

interface HeaderProps {
  parishes: ParishSummary[];
  activeParishId: string | null;
  onParishChange: (id: string) => void;
  subNav?: ReactNode;
  /** Opens the shared Settings drawer (from useSettingsDrawer). */
  settingsButtonProps: {
    onClick: () => void;
    'aria-haspopup': 'dialog';
    'aria-expanded': boolean;
  };
}

export function Header({
  parishes,
  activeParishId,
  onParishChange,
  subNav,
  settingsButtonProps,
}: HeaderProps): JSX.Element {
  // A fragment, not a row of our own: PortalHeader owns the slot layout so the
  // controls wrap onto their own line on a narrow screen (AUTH-1, cca-69gs).
  const rightSlot = (
    <>
      <ParishPicker parishes={parishes} activeParishId={activeParishId} onChange={onParishChange} />
      <button
        type="button"
        className="btn-header"
        aria-label="Settings"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        {...settingsButtonProps}
      >
        <GearIcon />
        Settings
      </button>
      <SignOutMenu onSignOut={signOutThisDevice} onSignOutAll={signOutAllDevices} />
    </>
  );

  return <PortalHeader portalName="Parish Portal" rightSlot={rightSlot} subNav={subNav} />;
}
